<div class="container-fluid p-1 p-lg-5 ">
  <div class="row g-0 px-3 px-lg-5">
    <div class="col-lg-5 d-none d-lg-flex flex-column left-panel ">

      <!-- Back + Logo -->
      <div class="d-flex align-items-center gap-2 mb-5">
        <a class="text-white  text-decoration-none me-1" style="font-size:1.2rem;" (click)="landingPage()"><i
            class="bi bi-arrow-left"></i></a>
        <span class="brand-logo"> <a class=" pe-3" (click)="landingPage()" style="cursor: pointer">
            <img src="logo/agrify-ai-white.png" class="img-fluid" />
          </a></span>
      </div>

      <!-- Headline -->
      <h2 class="panel-title mb-4">Global Fruit Trade,<br>Simplified.</h2>

      <!-- Features -->
      <div class="d-flex flex-column gap-3 mb-5">
        <div class="feature-item">
          <div class="feature-icon fi-green"><i class="bi bi-globe"></i></div>
          <div>
            <h6>Access Global Markets</h6>
            <p>Connect with verified buyers and sellers in over 120 countries instantly.</p>
          </div>
        </div>
        <div class="feature-item">
          <div class="feature-icon fi-blue"><i class="bi bi-graph-up"></i></div>
          <div>
            <h6>AI-Driven Insights</h6>
            <p>Make smarter decisions with real-time price predictions and demand forecasting.</p>
          </div>
        </div>
        <div class="feature-item">
          <div class="feature-icon fi-purple"><i class="bi bi-shield-shaded"></i></div>
          <div>
            <h6>Secure Transactions</h6>
            <p>Trade with confidence using our escrow services and smart contracts.</p>
          </div>
        </div>
      </div>

      <!-- Testimonial -->
     
      @if(step ==3){
      <div class="mt-auto testimonial-card">
        <div class="recovery-banner mb-3">
          <div class="recovery-icon-container">
          <i class="bi bi-shield-shaded"></i>
          </div>
          <div class="recovery-text-container">
            <div class="recovery-title">Secure Reset</div>
            <div class="recovery-subtitle">Protected and Encrypted</div>
          </div>
        </div>
        <p class="mb-3">"Simple password reset process with top-notch security."</p>
      </div>
      }@else{
      <div class="mt-auto testimonial-card">
        <div class="recovery-banner mb-3">
          <div class="recovery-icon-container">
            <i class="bi bi-unlock-fill"></i>
          </div>
          <div class="recovery-text-container">
            <div class="recovery-title">Password Recovery</div>
            <div class="recovery-subtitle">Fast & Secure</div>
          </div>
        </div>
        <p class="mb-3">"Quick and easy password reset. Back to trading in no time."</p>
      </div>
      }

    </div>

    <div class="col-12 col-lg-7 right-panel">
      <div style="max-width: 500px; width: 100%; margin: 0 auto;">

        <!-- ── STEP 1: ENTER EMAIL ────────────────── -->
        @if (step === 1) {
        <div class="text-center mb-4">
          <div class="step-icon-container mx-auto mb-3">
            <i class="bi bi-key-fill text-primary"></i>
          </div>
          <h2 class="form-title mb-1">Forgot Password?</h2>
          <p class="form-subtitle">No worries! Enter your email and we'll send you OTP</p>
        </div>

        <form [formGroup]="forgotEmailFormGroup" (ngSubmit)="onSubmit()">
          <div class="mb-4">
            <label class="form-label fw-semibold"
              [ngClass]="{ 'is-invalid-label': showError || ((submitted || f['emailId'].touched) && f['emailId'].errors) }">Email Address</label>
            <div class="input-group-custom">
              <span class="input-group-text-custom"
                [ngClass]="{ 'is-invalid-icon': showError || ((submitted || f['emailId'].touched) && f['emailId'].errors) }"><i
                  class="bi bi-envelope"></i></span>
              <input type="email" formControlName="emailId" class="form-control form-control-custom-v2"
                placeholder="name@company.com"
                [ngClass]="{ 'is-invalid': (submitted || f['emailId'].touched) && f['emailId'].errors }" />
            </div>
            <p class="text-muted mt-1" style="font-size: 0.75rem;" *ngIf="!f['emailId'].errors?.['required']">Enter the email associated with your account</p>
            <div *ngIf="(submitted || f['emailId'].touched) && f['emailId'].errors" class="text-danger mt-1"
              style="font-size: 0.75rem;">
              <span *ngIf="f['emailId'].errors?.['required']">Email is required</span>
              <span *ngIf="!f['emailId'].errors?.['required'] && f['emailId'].errors?.['email']">Please enter a valid email address</span>
            </div>
          </div>

          <div *ngIf="showError" class="login-error-alert mb-4">
            <div class="d-flex align-items-start gap-2">
              <div class="d-flex gap-2 justify-content-center align-items-center">
                 <i class="bi bi-exclamation-circle-fill fs-6"></i>
                 @if(errorMessage == '"No entity found for query"'){
                  <div class="error-text">Please enter a valid email address. </div>
                 }@else{
                  <div class="error-text">{{errorMessage}} </div>
                 }
              </div>
            </div>
          </div>

          <button type="submit" class="btn btn-primary-custom w-100 mb-4"
            [disabled]="loading">
            <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
            {{ loading ? 'Sending...' : 'Send OTP' }} <i class="bi bi-send-fill ms-2"></i>
          </button>
        </form>

        <div class="text-center mb-5">
          <a href="javascript:void(0)" (click)="landingPage()" class="back-link">
            <i class="bi bi-arrow-left me-2"></i> Back to Sign In
          </a>
        </div>

        <!-- Info Box -->
        <div class="info-box-blue p-3 d-flex gap-3 align-items-start">
          <i class="bi bi-info-circle-fill text-primary fs-5 mt-1"></i>
          <div style="font-size: 0.85rem;">
            <div class="fw-bold mb-1">Didn't receive the email?</div>
            <div class="text-muted">Check your spam folder or <a href="mailto:hi@agrify.ai" target="_blank"
                class="text-primary text-decoration-none" >contact support</a> for assistance.</div>
          </div>
        </div>
        }

        <!-- ── STEP 2: VERIFY OTP ─────────────────── -->
        @if (step === 2) {
        <div class="text-center mb-4">
          <div class="step-icon-container mx-auto mb-3" style="background: rgba(59, 130, 246, 0.1);">
            <i class="bi bi-shield-shaded text-primary"></i>
          </div>
          <h2 class="form-title mb-1">Verify OTP</h2>
          <p class="form-subtitle">Enter the 4-digit code sent to your email</p>
          <p class="text-primary fw-medium" style="font-size: 0.9rem;">{{ forgotEmailFormGroup.value.emailId }}</p>
        </div>

        <form [formGroup]="requestPinForm" (ngSubmit)="onRequestPinFormSubmit()">
          <div class="mb-4">
            <p class="text-center fw-medium mb-3" style="font-size: 0.9rem;">Enter Verification Code</p>
            <div class="d-flex justify-content-center gap-2 mb-3">
              <input type="text" class="form-control otp-digit-box" maxlength="1" (input)="onOtpChange($event, 0)"
                (keydown)="onOtpKeyDown($event, 0)" [ngClass]="{ 'is-invalid': showError }" />
              <input type="text" class="form-control otp-digit-box" maxlength="1" (input)="onOtpChange($event, 1)"
                (keydown)="onOtpKeyDown($event, 1)" [ngClass]="{ 'is-invalid': showError }" />
              <input type="text" class="form-control otp-digit-box" maxlength="1" (input)="onOtpChange($event, 2)"
                (keydown)="onOtpKeyDown($event, 2)" [ngClass]="{ 'is-invalid': showError }" />
              <input type="text" class="form-control otp-digit-box" maxlength="1" (input)="onOtpChange($event, 3)"
                (keydown)="onOtpKeyDown($event, 3)" [ngClass]="{ 'is-invalid': showError }" />
            </div>
            <div class="text-center">
              <span class="text-muted" style="font-size: 0.85rem;">Didn't receive OTP? </span>
              <a href="javascript:void(0)" (click)="resendOtp()" class="text-primary text-decoration-none fw-bold"
                style="font-size: 0.85rem;">Resend OTP</a>
            </div>
            <!-- <div *ngIf="requestPinFormSubmitted && requestPinFormControls['pin'].errors?.['required']"
              class="text-danger text-center mt-2" style="font-size: 0.75rem;">
              Pin is required
            </div> -->
          </div>

          <div *ngIf="showError" class="login-error-alert mb-4">
            <div class="d-flex align-items-start gap-2">
              <div class="d-flex gap-2 justify-content-center align-items-center">
                 <i class="bi bi-exclamation-circle-fill fs-6"></i>
                <div class="error-text">{{errorMessage}} </div>
              </div>
            </div>
          </div>

          <button type="submit" class="btn btn-primary-custom w-100 mb-4"
            [disabled]="sendingPin">
            <span *ngIf="sendingPin" class="spinner-border spinner-border-sm me-2"></span>
            Verify <i class="bi bi-check-lg ms-2"></i>
          </button>
        </form>

        <div class="text-center mb-5">
          <a href="javascript:void(0)" (click)="goToStep(1)" class="back-link">
            <i class="bi bi-arrow-left me-2"></i> Back to Sign In
          </a>
        </div>

        <!-- Info Box Green -->
        <div class="info-box-green p-3 d-flex gap-3 align-items-center">
          <i class="bi bi-info-circle-fill text-success fs-5"></i>
          <div style="font-size: 0.85rem;" class="fw-medium">Code expires in 10 minutes</div>
        </div>
        }

        <!-- ── STEP 3: RESET PASSWORD ────────────── -->
        @if (step === 3) {
        <div class="text-center mb-4">
          <div class="step-icon-container mx-auto mb-3" style="background: rgba(16, 185, 129, 0.1);">
            <i class="bi bi-unlock-fill text-success"></i>
          </div>
          <h2 class="form-title mb-1">Reset Your Password</h2>
          <p class="form-subtitle">Create a new secure password for your account</p>
        </div>

        <form [formGroup]="requestPinForm" (ngSubmit)="onRequestPinFormSubmit()">
          <div class="mb-3">
            <label class="form-label fw-semibold"
              [ngClass]="{ 'is-invalid-label': requestPinFormSubmitted && (showError || requestPinFormControls['password'].errors) }">New Password</label>
            <div class="input-group-custom">
              <span class="input-group-text-custom"
                [ngClass]="{ 'is-invalid-icon': requestPinFormSubmitted && (showError || requestPinFormControls['password'].errors) }"><i
                  class="bi bi-lock-fill"></i></span>
              <input [type]="showPassword ? 'text' : 'password'" formControlName="password"
                class="form-control form-control-custom-v2" placeholder="Enter new password"
                [ngClass]="{ 'is-invalid': requestPinFormSubmitted && (showError || requestPinFormControls['password'].errors) }" />
              <span class="input-group-text-custom-right" (click)="togglePasswordVisibility()">
                <i [class]="showPassword ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
              </span>
            </div>
            <div *ngIf="requestPinFormSubmitted && requestPinFormControls['password'].errors?.['required']"
              class="text-danger mt-1" style="font-size: 0.75rem;">
              Password is required
            </div>
          </div>

          <div class="mb-4">
            <label class="form-label fw-semibold"
              [ngClass]="{ 'is-invalid-label': requestPinFormSubmitted && (showError || requestPinFormControls['confirmPassword'].errors || requestPinForm.errors?.['passwordMismatch']) }">Confirm Password</label>
            <div class="input-group-custom">
              <span class="input-group-text-custom"
                [ngClass]="{ 'is-invalid-icon': requestPinFormSubmitted && (showError || requestPinFormControls['confirmPassword'].errors || requestPinForm.errors?.['passwordMismatch']) }"><i
                  class="bi bi-lock-fill"></i></span>
              <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword"
                class="form-control form-control-custom-v2" placeholder="Re-enter new password"
                [ngClass]="{ 'is-invalid': requestPinFormSubmitted && (showError || requestPinFormControls['confirmPassword'].errors || requestPinForm.errors?.['passwordMismatch']) }" />
              <span class="input-group-text-custom-right" (click)="toggleConfirmPasswordVisibility()">
                <i [class]="showConfirmPassword ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
              </span>
            </div>
            <div *ngIf="requestPinFormSubmitted" class="text-danger mt-1" style="font-size: 0.75rem;">
              <span *ngIf="requestPinFormControls['confirmPassword'].errors?.['required']">Confirm password is required</span>
              <span *ngIf="requestPinForm.errors?.['passwordMismatch'] && !requestPinFormControls['confirmPassword'].errors">Passwords do not match</span>
            </div>
          </div>

          <div *ngIf="showError" class="login-error-alert mb-4">
            <div class="d-flex align-items-start gap-2">
               <div class="d-flex gap-2 justify-content-center align-items-center">
                 <i class="bi bi-exclamation-circle-fill fs-6"></i>
                <div class="error-text">{{errorMessage}} </div>
              </div>
            </div>
          </div>

          <!-- Password Requirements -->
          <div class="info-box-blue p-3 mb-4">
            <div class="d-flex align-items-center gap-2 mb-2">
              <i class="bi bi-check-circle-fill text-success"></i>
              <span class="fw-bold" style="font-size: 0.85rem;">Password Requirements:</span>
            </div>
            <ul class="ps-4 mb-0 text-muted" style="font-size: 0.75rem; list-style-type: disc;">
              <li>At least 8 characters long</li>
              <li>Contains uppercase and lowercase letters</li>
              <li>Includes at least one number</li>
              <li>Contains a special character (!@#$%^&*)</li>
            </ul>
          </div>

          <button type="submit" class="btn btn-primary-custom w-100 mb-4"
            [disabled]="sendingPin">
            <span *ngIf="sendingPin" class="spinner-border spinner-border-sm me-2"></span>
            Reset Password <i class="bi bi-check-lg ms-2"></i>
          </button>
        </form>

        <div class="text-center">
          <a href="javascript:void(0)" (click)="landingPage()" class="back-link">
            <i class="bi bi-arrow-left me-2"></i> Back to Sign In
          </a>
        </div>
        }

      </div>
    </div>
  </div>
</div>



<!-- <div class="container-fluid row m-0 p-0 vw-100 flex-fill">
  <div class="col-12 col-md-12 mb-4 pb-4 pt-4 ps-3 pt-5 mt-lg-0 pt-5 pt-lg-0">
    <div class="d-flex flex-column vh-100 mt-4 pt-4 mx-auto content-container">
      <div class="text-start" style="width: 300px">
        <h3 style="color: #080b53;">
          {{ !passwordRestDone ? (emailSent ? 'Reset Password' : 'Forgot Password') : 'Password Changed' }}
        </h3>
        <h6 class="text-muted" *ngIf="!passwordRestDone">
          {{ emailSent ? 'Verify code and set new password' : 'Enter email to reset password' }}
        </h6>
      </div>

      <div class="w-100">
        @if(!emailSent && !passwordRestDone){
        <form [formGroup]="forgotEmailFormGroup" (ngSubmit)="onSubmit()" class="w-100">
          <div class="w-100 custom-form-field">
            <label for="emailId">Email Id / Phone Number</label>
            <input matInput type="text" placeholder="Enter email or phone" formControlName="emailId" id="emailId"
              required />
          </div>

          @if((submitted && f['emailId'].errors) || f['emailId'].touched){
          <div style="font-size: 10px" class="text-danger text-start w-100 mb-2 ps-1">
            @if(f['emailId'].errors?.['required']){
            <span style="font-size: 10px">Email Id/Phone number is required</span>
            } @else if(f['emailId'].errors?.['serverError']){
            <span style="font-size: 10px">{{ errorMessage }}</span>
            }
          </div>
          }

          <div class="btn-group-forgot">
            <button type="submit" class="next-btn" [disabled]="loading">
              <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
              Reset Password
            </button>
            <div class="small mt-3 text-center">
              Back to Login?
              <a style="color: #080b53" routerLink="/login"><span class="fw-medium">Login</span></a>
            </div>
          </div>
        </form>
        } @else if(emailSent && !passwordRestDone){
        <form [formGroup]="requestPinForm" (ngSubmit)="onRequestPinFormSubmit()" class="w-100">
         

          <div class="w-100 custom-form-field">
            <label for="pin">Pin</label>
            <input matInput type="text" placeholder="Enter PIN" formControlName="pin" id="pin" maxlength="6" required />
          </div>
          @if(requestPinFormSubmitted && requestPinFormControls['pin'].errors){
          <div style="font-size: 10px" class="text-danger text-start w-100 mb-2 ps-1">
            <span>Pin is required</span>
          </div>
          }

          <div class="w-100 custom-form-field">
            <label for="password">New Password</label>
            <input matInput type="password" placeholder="New Password" formControlName="password" id="password"
              required />
          </div>
          @if(requestPinFormControls['password'].errors && (requestPinFormControls['password'].dirty ||
          requestPinFormControls['password'].touched)){
          <div style="font-size: 10px" class="text-danger text-start w-100 mb-2 ps-1 d-flex flex-column">
            <span *ngIf="requestPinFormControls['password'].errors['hasNumber']">Password must contain a number.</span>
            <span *ngIf="requestPinFormControls['password'].errors['hasCapitalCase']">Password must contain an uppercase
              letter.</span>
            <span *ngIf="requestPinFormControls['password'].errors['hasSmallCase']">Password must contain a lowercase
              letter.</span>
            <span *ngIf="requestPinFormControls['password'].errors['minlength']">Password must be at least 8 characters
              long.</span>
            <span *ngIf="requestPinFormControls['password'].errors['required']">Password is required.</span>
          </div>
          }

          <div class="w-100 custom-form-field">
            <label for="confirmPassword">Confirm Password</label>
            <input matInput type="password" placeholder="Confirm Password" formControlName="confirmPassword"
              id="confirmPassword" required />
          </div>
          @if(requestPinFormSubmitted && requestPinFormControls['confirmPassword'].errors){
          <div style="font-size: 10px" class="text-danger text-start w-100 mb-2 ps-1">
            <span *ngIf="requestPinFormControls['confirmPassword'].errors['required']">Confirm Password is
              required</span>
          </div>
          }
          @if(requestPinForm?.errors?.['passwordMismatch'] && (requestPinFormControls['confirmPassword']?.touched ||
          requestPinFormControls['confirmPassword']?.dirty)){
          <div style="font-size: 10px" class="text-danger text-start w-100 mb-2 ps-1">
            <span>Password and Confirm Password do not match.</span>
          </div>
          }
          <div class="text-center mb-3 mt-2">
            <h6 class="small">Verification code sent to {{forgotEmailFormGroup.get('emailId')?.value}}</h6>
          </div>

          <div class="btn-group-forgot">
            <button type="submit" class="next-btn" [disabled]="sendingPin">
              <span *ngIf="sendingPin" class="spinner-border spinner-border-sm me-2"></span>
              Confirm Reset
            </button>
            <div class="small mt-3 text-center">
              Back to Login?
              <a style="color: #080b53" routerLink="/login"><span class="fw-medium">Login</span></a>
            </div>
          </div>
        </form>
        } @else if(passwordRestDone){
        <div class="text-center w-100">
          <div class="alert alert-success mt-4">
            Your password has been successfully changed.
          </div>
          <button type="button" class="next-btn mt-3" routerLink="/login">Login Now</button>
        </div>
        }
      </div>
    </div>
  </div>
</div> -->